import { Observable } from 'rxjs';
import { BrowsingContextError } from '../../browsingContextError';
import { createConnectingService } from '../base/connectingService';
import { BaseService, createService, NULL_SERVICE, Service, ServiceLike } from '../base/service';

export function createElementEffectService<T extends Element>(
  element$: Observable<T | null>,
  getEffects$: (element: T, document: Document, window: Window) => Observable<any>,
): Service {
  return createConnectingService(
    element$,
    () => NULL_SERVICE,
    element => {
      const elementService = new ElementService(element);
      const { document, window } = elementService;

      return createService(elementService, {
        effects$: getEffects$(element, document, window),
      });
    },
  );
}

export class ElementService<T extends Element> extends BaseService {
  constructor(element: T, ...dependencies: ServiceLike[]) {
    const document = element.ownerDocument;
    if (!document) {
      throw new BrowsingContextError();
    }

    const window = document.defaultView;
    if (!window) {
      throw new BrowsingContextError();
    }

    super(...dependencies);

    this.element = element;
    this.document = document;
    this.window = window;
  }

  readonly element: T;
  readonly document: Document;
  readonly window: Window;
}
